export const getAnimationState = (state: boolean | null, activeClass: string, inactiveClass: string) => {
  if (state === null) {
    return '';
  }
  if (state) {
    return activeClass;
  }
  return inactiveClass;
};
